/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import { pathConstants } from "@/shared/pathConstants";
import { webSocketService } from "@/services";
import { cloneDeep } from "lodash";
import Vue from "vue";
import store from "@/store";
import { constants } from "@/shared/constants";

const lookup = function(pagedFilter, showLoader = true) {
  const customPagedFilter = cloneDeep(pagedFilter);
  if (customPagedFilter.myPager.page > 1) {
    customPagedFilter.myPager.page = customPagedFilter.myPager.page - 1;
  } else {
    customPagedFilter.myPager.page = 0;
  }
  return axios
    .post(pathConstants.API + "/users/clientUsers", customPagedFilter, {
      showLoader
    })
    .then(response => response.data)
    .catch(error => error);
};

const agenceUsers = function(pagedFilter, id, showLoader = true) {
  const customPagedFilter = cloneDeep(pagedFilter);
  if (customPagedFilter.myPager.page > 1) {
    customPagedFilter.myPager.page = customPagedFilter.myPager.page - 1;
  } else {
    customPagedFilter.myPager.page = 0;
  }
  return axios
    .post(
      pathConstants.API + `/users/agenceUsers?id=${id}`,
      customPagedFilter,
      { showLoader }
    )
    .then(response => response.data)
    .catch(error => error);
};

const agenceUsersList = function(id) {
  return axios
    .get(pathConstants.API + `/users/agenceUsers?id=${id}`)
    .then(response => response.data)
    .catch(error => error);
};

const clientUsersList = function(id) {
  return axios
    .get(pathConstants.API + `/users/clientUsers`)
    .then(response => response.data)
    .catch(error => error);
};

const clientUsersByRole = function(id) {
  return axios
    .get(pathConstants.API + `/users/clientUsersByRole`)
    .then(response => response.data)
    .catch(error => error);
};

const changeActivation = function(activationUserGwtDto) {
  store.commit("loader/showActivateUserLoader");
  store.commit("user/setShouldLoading", activationUserGwtDto.id);
  return axios
    .post(
      pathConstants.API + "/users/activate-user",
      {
        id: activationUserGwtDto.id,
        isEnable: activationUserGwtDto.isEnabled,
        assignedUser: activationUserGwtDto.assignedUser
      },
      { showLoader: false }
    )
    .then(response => response.data)
    .catch(error => {
      Vue.$log.error("changeActivation", error);
      if (error.response?.data?.errorCode === constants.ERROR_CODE.GWBE00016) {
        store.commit("user/setAffected", true);
      }
    })
    .finally(() => {
      store.commit("loader/hideActivateUserLoader");
      store.commit("user/setShouldNotLoading", activationUserGwtDto.id);
    });
};

const fetchUserInfo = function(establishWSConnection) {
  return axios
    .get(pathConstants.API + "/accounts/info")
    .then(response => {
      if (establishWSConnection) {
        webSocketService.connect(response.data.email);
      }
      return response.data;
    })
    .catch(error => error);
};

const addUser = function(userDto) {
  return axios.post("/api/users/add-user", userDto).then(
    result => {
      if (result.data) {
        return result.data;
      } else {
        return {};
      }
    },
    err => {
      Vue.$log.error("addUser", err);
    }
  );
};

const modifyUser = function(userDto) {
  return axios.post("/api/users/modify-user", userDto).then(
    result => {
      if (result.data) {
        return result.data;
      } else {
        return {};
      }
    },
    err => {
      Vue.$log.error("modifyUser", err);
    }
  );
};

const modifyUserActiveAgence = function(userDto) {
  return axios.post("/api/users/modify-user-agence", userDto).then(
    result => {
      if (result.data) {
        result.data.clientType = userDto.clientType;
        store.commit("account/setUserInfo", result.data);
        return result.data;
      } else {
        return {};
      }
    },
    err => {
      Vue.$log.error("modifyUser", err);
    }
  );
};

const modifyUserConfig = function(userDto) {
  return axios.post("/api/users/modify-user-config", userDto).then(
    result => {
      if (result.data) {
        return result.data;
      } else {
        return {};
      }
    },
    err => {
      Vue.$log.error("modifyUserConfig", err);
    }
  );
};

const showRoles = function() {
  return axios
    .get("/api/roles/")
    .then(response => response.data)
    .catch(error => error);
};

const updateProfile = function(dto) {
  return axios
    .post("/api/users/update-profile", dto)
    .then(response => {
      Vue.prototype.$notification.success(
        "Votre modification a été enregitrée avec succès"
      );
      return response;
    })
    .catch(error => error);
};

export const userService = {
  lookup,
  agenceUsers,
  agenceUsersList,
  fetchUserInfo,
  addUser,
  showRoles,
  modifyUser,
  modifyUserActiveAgence,
  modifyUserConfig,
  changeActivation,
  updateProfile,
  clientUsersList,
  clientUsersByRole
};
